__turbopack_context__.v({
  "questionLevel": "QuestionLevel-module__emGE2G__questionLevel",
  "questionLevel1": "QuestionLevel-module__emGE2G__questionLevel1",
  "questionLevel2": "QuestionLevel-module__emGE2G__questionLevel2",
  "questionLevel3": "QuestionLevel-module__emGE2G__questionLevel3",
});
